module.exports = __webpack_public_path__ + "img/shopcar2.a8dc5d9e.png";